
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const finka: Operator = {
	id: 'finka',
	name: 'Finka',
	role: 'Attacker',
	org: 'CBRN THREAT UNIT',
	squad: 'NIGHTHAVEN',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 1
	},
	meta: {
		gender: 'f',
		country: 'ru',
		season: 'Y3S1',
		height: 171,
		weight: 68,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Lera Melnikova',
		birthplace: 'Gomel, Belarus'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#fead33"></path><path d="m157.292 21.792 19.958 9.083 3.458 10.792 20.597-1.5 8.25 12.111 19.333 2.556 7.132 17.729 15.688 3.938 12.083 15.875-6.417 9.125 11.583 4 8.792 15.944-6.354 9.16v32.438L197.417 277H93.167L118 232.917l-5.004 6.593 27.671-47.343-21.778-43.278-4.556-61.722 33.722-38.889z" style="fill:#fff"></path><path d="m160.25 29.25 12.75 5.5 2.75 8.667-25.667 37.667L156 98.833l16.333 3.667 13.333 38a129 129 0 0 0-1.083 11.333c-.283 5.566-.07 8.596-.167 17.583a486 486 0 0 1-.167 8.583 331 331 0 0 1 1.75-8.5c1.356-6.176 2.204-9.198 2.917-12.333.916-4.028 1.966-9.809 2.417-17.167l-7.25-20.5 15.667 5 9.333 15.333 16 2.75 8.167 10.583 17.333 7.333 16.5-23.75-.667 25-52.528 89-16.472 26.25h-17.667l61.125-111.125-75.458 96 15-50.75L110.979 277H89.611L118 232.917l28.833-40.333-22.5-44.917L120 88.889l32.792-37.91z"></path><path d="m179.542 47.125 19-1.5 6.083 9.125-29.958 42.708-14.584-2.791-4.208-12.709zm29.708 10.542 15.792 2.042L231 74.583l-30.417 44.333-14-4.167-8.302-12.948zm26.111 20.194 13.222 3.25 8.5 11.25-31.611 44.611-13.111-1.916-7.472-12.889zm18.667 28.083L265 109.833l6.417 11.361-22.889 32.75-11.278-4.548-7.25-9.507zm-96.695 142.973-35.812 63.812-9.042-6.125z"></path><path d="M45 264.333v13.834l43-60.5zm79.667-60.25L57.417 305H45v-5z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-finka'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
